<template>
  <div class="row main m-0">
    <div
      v-if="categoriesView"
      ref="categories"
      class="main__categories pl-0 pr-0 col"
    >
      <div class="main__categories_wrap justify-content-start d-flex">
        <category
          v-for="category in main_categories"
          :key="category.id"
          :category_id="category.id"
          :title="category.title"
          :icon="category.icon"
        />

        <div
          v-if="!catsShown"
          class="d-flex justify-content-center container-fluid pt-2"
        >
          <router-link
            :to="{ name: 'categories' }"
            class="bordered-btn blue-button more-cats"
            tag="button"
            @click.native="moreCatsClick()"
          >
            {{ $t("More categories") }}
          </router-link>
        </div>

        <category
          v-for="category in cats"
          v-if="catsShown"
          :key="category.id"
          :category_id="category.id"
          :title="category.title"
          :icon="category.icon"
        />
      </div>
    </div>

    <div
      v-if="childrenView"
      ref="category_children"
      class="col p-0 category_children"
    >
      <router-view name="children" />
    </div>

    <div class="side-buttons">
      <router-link
        v-if="$route.name !== 'main'"
        :to="{ name: 'main' }"
        class="side-buttons__button"
        tag="div"
        @click.native="goHome"
      >
        <i class="fa fa-times"></i>
      </router-link>
      <div class="side-buttons__button" @click="toggleDisplaySidebar()">
        <i v-if="sidebarDisplay" class="fa fa-chevron-left"></i>
        <i v-else class="fa fa-chevron-right"></i>
      </div>
    </div>
  </div>
</template>

<script>
import Map from "../Map";
import Category from "./templates/Category";

export default {
  components: {
    Category,
  },
  data() {
    return {
      main_categories: [],
      cats: OTHER_CATEGORIES,
      sidebarDisplay: true,
      sidebarElement: null,
    };
  },
  computed: {
    childrenView() {
      return this.$store.getters.getChildrenView;
    },
    categoriesView() {
      return this.$store.getters.getCategoriesView;
    },
    catsShown() {
      return this.$store.getters.getAllCategoriesShown;
    },
    categoriesCol() {
      return this.$store.getters.getCategoriesCol;
    },
    categoryChildrenCol() {
      return this.$store.getters.getCategoryChildrenCol;
    },
  },
  created() {
    this.$store.commit("setMap", new Map());

    if (this.$store.getters.getLocation === null) this.setLocation();
  },
  mounted() {
    this.sidebarElement = $(".catalog .catalog-sidebar");
    this.$store.dispatch("setRefs", this);
    let top_search = this.$parent.$refs["top-search"];

    if (typeof top_search !== "undefined")
      top_search.style.setProperty("display", "none", "important");

    this.windowActions();

    if (!this.isListening("main")) {
      window.addEventListener("popstate", (event) => {
        this.windowActions();
      });

      this.$store.commit("setPopstsateListener", {
        name: "main",
        value: true,
      });
    }

    if (typeof MAIN_CATEGORIES === "object")
      this.main_categories = MAIN_CATEGORIES;

    let map = this.$store.getters.getMap;
    if (this.$store.getters.getLocation == null) {
      this.$store.commit("setLocation", FILTER.location);
    }

    if (this.$store.getters.getLocation.latlng === "") {
      let geocoder = new google.maps.Geocoder();
      let self = this;
      geocoder.geocode(
        { address: self.$route.query.address },
        function (results, status) {
          if (results === null) return; //must use geocoder api key

          self.$store.commit("setLocation", {
            address: self.$route.query.address,
            latlng:
              results[0].geometry.location.lat() +
              "," +
              results[0].geometry.location.lng(),
          });
          map.create(
            self.$parent.$refs["catalog-map"],
            self.$store.getters.getLocation.latlng
          );
        }
      );
    } else {
      map.create(
        this.$parent.$refs["catalog-map"],
        this.$store.getters.getLocation.latlng
      );
    }
  },
  methods: {
    setLocation() {
      let address = this.$route.query.address;
      if (address && address !== "/") {
        this.$store.commit("setLocation", {
          latlng: "",
          address: this.$route.query.address,
        });
        return;
      }

      if (this.$route.query.location) {
        this.$store.commit("setLocation", this.$route.query.location);
      } else {
        // this.$store.commit('setLocation', FILTER.location)
      }
    },
    goHome() {
      if (!this.sidebarDisplay) this.toggleDisplaySidebar(true);

      let sidebar = this.$store.getters.getRef("sidebar");
      sidebar.classList.add("home-shown");
      sidebar.classList.remove("filter-shown");

      this.windowActions();
    },
    toggleDisplaySidebar(state) {
      let sidebarDisplay = this.sidebarDisplay,
        sidebar = this.sidebarElement,
        sidebarWidth = sidebar[0].offsetWidth;

      switch (true) {
        case state !== undefined:
          switch (state) {
            case true:
              if (sidebarDisplay) break;
              $(sidebar).animate(
                {
                  "margin-left": "+=" + sidebarWidth,
                },
                250,
                () => {
                  this.sidebarDisplay = state;
                }
              );
              break;
            case false:
              if (!sidebarDisplay) break;
              $(sidebar).animate(
                {
                  "margin-left": "-=" + sidebarWidth,
                },
                250,
                () => {
                  this.sidebarDisplay = state;
                }
              );
              break;
          }

          break;
        case sidebarDisplay:
          $(sidebar).animate(
            {
              "margin-left": "-=" + sidebarWidth,
            },
            250,
            () => {
              this.sidebarDisplay = !sidebarDisplay;
            }
          );
          break;
        case !sidebarDisplay:
          $(sidebar).animate(
            {
              "margin-left": "+=" + sidebarWidth,
            },
            250,
            () => {
              this.sidebarDisplay = !sidebarDisplay;
            }
          );
          break;
      }
    },
    setRefs() {
      for (var i in this.$parent.$refs)
        this.$store.commit("setRef", {
          name: i,
          value: this.$parent.$refs[i],
        });

      for (var IN in this.$refs)
        this.$store.commit("setRef", {
          name: IN,
          value: this.$refs[IN],
        });
    },
    moreCatsClick() {
      this.$store.commit("setAllCategoriesShown", true);
      this.$store.commit("setChildrenView", false);
      this.$store.commit("triggerDynamicH1Resize");
    },
    isCategoryChildren() {
      return this.$route.name === "category";
    },
    isCategories() {
      return this.$route.name === "categories";
    },
    isListening(name) {
      return this.$store.getters.getPopstsateListener(name);
    },
    windowActions() {
      this.$store.commit(
        "setMetaTitle",
        this.$t("Are you looking for the best price of an offer via")
      );
      this.$store.commit("setH1", this.$t("catalog.catalog_heading"));
      this.$store.commit("triggerDynamicH1Resize");

      let sidebar = this.$store.getters.getRef("sidebar");

      if (window.screen.width <= 768) {
        switch (true) {
          case this.isCategoryChildren():
            this.$store.commit("setCategoriesView", false);
            this.$store.commit("setChildrenView", true);
            sidebar.classList.remove("home-shown");
            break;
          case this.isCategories():
            this.$store.commit("setAllCategoriesShown", true);
            this.$store.commit("setChildrenView", false);
            this.$store.commit("setCategoriesView", true);
            break;
          case this.$route.name === "main": //main catalog
            this.$store.commit("setAllCategoriesShown", false);
            this.$store.commit("setChildrenView", false);
            this.$store.commit("setCategoriesView", true);
            sidebar.classList.add("home-shown");
            break;
        }

        return;
      }

      switch (true) {
        case this.isCategoryChildren():
          this.$store.commit("setChildrenView", true);
          this.$store.commit("setCategoriesView", true);
          break;
        case this.isCategories():
          this.$store.commit("setAllCategoriesShown", true);
          this.$store.commit("setChildrenView", false);
          this.$store.commit("setCategoriesView", true);
          break;
        case this.$route.name === "main": //main catalog
          this.$store.commit("setAllCategoriesShown", false);
          this.$store.commit("setChildrenView", false);
          this.$store.commit("setCategoriesView", true);
          sidebar.classList.add("home-shown");
          sidebar.classList.remove("filter-shown");
          break;
      }
    },
  },
};
</script>
